@if (user$ | async; as user) {
    @switch (user.status) {
        @case ('pending') {
            <div class="container">
                <div class="logo-area text-center">
                    <app-brunata-online-logo-component />
                </div>
                <div class="text-center mb-3">
                    <h1>{{ 'information_startWelcome' | translate: 'online' : 'common' }}</h1>
                </div>
                <div class="mb-5">
                    <p>
                        {{ 'default_startPara1' | translate: 'online' : 'landingPage' }}
                    </p>
                    <ul>
                        <li>{{ 'default_startPara2' | translate: 'online' : 'landingPage' }}</li>
                        <li>{{ 'default_startPara3' | translate: 'online' : 'landingPage' }}</li>
                    </ul>
                    <p>
                        {{ 'default_startPara4' | translate: 'online' : 'landingPage' }}
                    </p>
                </div>
                <!-- Action buttons -->
                <div class="button-group mb-5">
                    <button type="button" class="btn btn-primary action-button" (click)="login()">
                        {{ 'actions_login' | translate: 'online' : 'common' }}
                    </button>
                    <button
                        type="button"
                        class="btn btn-outline-primary action-button"
                        (click)="newUser()">
                        {{ 'actions_newUser' | translate: 'online' : 'common' }}
                    </button>
                </div>

                <!-- Accordion info -->
                <div ngbAccordion [closeOthers]="true" class="accordion-flush">
                    <!-- Admin -->
                    <div ngbAccordionItem>
                        <h2 ngbAccordionHeader>
                            <button ngbAccordionButton>
                                {{ 'default_ADMIN' | translate: 'online' : 'landingPage' }}
                            </button>
                        </h2>
                        <div ngbAccordionCollapse>
                            <div ngbAccordionBody>
                                <ng-template>
                                    <p>
                                        {{
                                            'default_adminPara1'
                                                | translate: 'online' : 'landingPage'
                                        }}
                                    </p>
                                    <p>
                                        {{
                                            'default_adminPara2'
                                                | translate: 'online' : 'landingPage'
                                        }}
                                    </p>
                                    <p>
                                        {{
                                            'default_adminPara3'
                                                | translate: 'online' : 'landingPage'
                                        }}
                                    </p>
                                </ng-template>
                            </div>
                        </div>
                    </div>
                    <!-- Sub-user -->
                    <div ngbAccordionItem>
                        <h2 ngbAccordionHeader>
                            <button ngbAccordionButton>
                                {{ 'default_SUBUSER' | translate: 'online' : 'landingPage' }}
                            </button>
                        </h2>
                        <div ngbAccordionCollapse>
                            <div ngbAccordionBody>
                                <ng-template>
                                    <p>
                                        {{
                                            'default_subUserPara1'
                                                | translate: 'online' : 'landingPage'
                                        }}
                                    </p>
                                    <p>
                                        {{
                                            'default_subUserPara2'
                                                | translate: 'online' : 'landingPage'
                                        }}
                                    </p>
                                    <p>
                                        {{
                                            'default_subUserPara3'
                                                | translate: 'online' : 'landingPage'
                                        }}
                                    </p>
                                    <p>
                                        {{
                                            'default_subUserPara4'
                                                | translate: 'online' : 'landingPage'
                                        }}
                                    </p>
                                </ng-template>
                            </div>
                        </div>
                    </div>
                    <!-- Resident -->
                    <div ngbAccordionItem>
                        <h2 ngbAccordionHeader>
                            <button ngbAccordionButton>
                                {{ 'default_RESIDENT' | translate: 'online' : 'landingPage' }}
                            </button>
                        </h2>
                        <div ngbAccordionCollapse>
                            <div ngbAccordionBody>
                                <ng-template>
                                    <p>
                                        {{
                                            'default_residentPara1'
                                                | translate: 'online' : 'landingPage'
                                        }}
                                    </p>
                                    <p>
                                        {{
                                            'default_residentPara2'
                                                | translate: 'online' : 'landingPage'
                                        }}
                                    </p>
                                    <p>
                                        {{
                                            'default_residentPara3'
                                                | translate: 'online' : 'landingPage'
                                        }}
                                    </p>
                                </ng-template>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        }
        @case ('loading') {
            <app-load />
        }
    }
}
